import { createContext, Dispatch, SetStateAction } from 'react';
import { Socket } from 'socket.io-client';

export interface socketContextType {
  socket: Socket | null;
  updateSocket: Dispatch<SetStateAction<Socket | null>>;
}

export const SocketContext = createContext<socketContextType>(null!);
